import { useSelector} from 'react-redux';

import AppliedFilters from "../AppliedFilters/AppliedFilters";
import FilterMenu from "../FilterMenu/FilterMenu";
import FloorplanList from "../FloorplanList/FloorplanList";
import SelectSceneModal from "../SelectSceneModal/SelectSceneModal";
import TopMenu from "../TopMenu/TopMenu";
import HelpModal from '../HelpModal/HelpModal';
import styles from './FloorPlansPage.module.css';


export default function FloorPlansPage() {
  const sceneModalStatus = useSelector((state) => state.ui.sceneModalActive);
  const helpModalStatus = useSelector((state) => state.ui.helpModalActive);
  const activeCommunity = useSelector((state) => state.visualizer.activeCommunity);

  return (
    <>
      <TopMenu extended={false} />

      <section className={styles.container}>
        <h3>Choose a Floor Plan</h3>
        <FilterMenu />
        <AppliedFilters />
        <FloorplanList />
      </section>

      {helpModalStatus && <HelpModal />}
      {sceneModalStatus && <SelectSceneModal />}

    </>
  );
}